import './styles/Loading.css';
interface loaderProps {
  message: string;
}
const Loading: React.FC<loaderProps> = ({ message }) => {
  return (
    <div className="loader-overlay">
      <div className="loader"></div>
      <div className="loader-text">{message}</div>
    </div>
  );
};

export default Loading;
